import { render, staticRenderFns } from "./UpdateDiscountQualification.vue?vue&type=template&id=640f4917&scoped=true&"
import script from "./UpdateDiscountQualification.vue?vue&type=script&lang=js&"
export * from "./UpdateDiscountQualification.vue?vue&type=script&lang=js&"
import style0 from "./UpdateDiscountQualification.vue?vue&type=style&index=0&id=640f4917&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640f4917",
  null
  
)

export default component.exports